import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function TopMenuBar({ address, credits, onEditAddress, onAddCredits }) {
  const navigate = useNavigate();
  // Only show the street address (before the first comma), truncated to 11 characters
  let streetAddress = address ? address.split(',')[0] : 'Set Address';
  if (streetAddress.length > 11) streetAddress = streetAddress.slice(0, 11) + '...';

  return (
    <div className="top-menu-bar">
      <div className="top-menu-section" onClick={onEditAddress} style={{ cursor: 'pointer', gap: 6 }}>
        <span className="top-menu-address">{streetAddress}</span>
        <span className="top-menu-arrow" style={{ fontSize: 16, marginLeft: 2 }}>▼</span>
      </div>
      <div className="top-menu-section" onClick={onAddCredits} style={{ cursor: 'pointer', gap: 6, marginLeft: 48 }}>
        <span className="top-menu-credits" style={{ gap: 4 }}>
          <img src="/coin-20749_256.gif" alt="credits" style={{ width: 20, height: 20, marginRight: 2, verticalAlign: 'middle' }} />
          {credits ?? 0}
        </span>
        <span className="top-menu-plus" style={{ fontSize: 20, fontWeight: 700, marginLeft: 2 }}>+</span>
      </div>
      <div style={{ flex: 1 }} />
      <div className="top-menu-section" style={{ marginLeft: 18, cursor: 'pointer' }} onClick={() => navigate('/settings')}>
        <span style={{ color: '#fff', fontWeight: 500, letterSpacing: 0.5 }}>
          Settings
        </span>
      </div>
    </div>
  );
} 